
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/irpf/forum",
      function () {
        return require("private-next-pages/irpf/forum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/irpf/forum"])
      });
    }
  